import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {
	constructor() {
	}
	public get getAdalConfig(): any {
		return {
			tenant: '6614e0da-1c72-4a24-a4e9-96c46265649a',
			clientId: 'f8c68e66-e00b-4a27-b92d-842480c845bd',
			redirectUri: window.location.origin + '/',
			postLogoutRedirectUri: window.location.origin + '/#/logout',
			loadFrameTimeout: 30000,
			expireOffsetSeconds: 600,
			endpoints: {
				graphApiUri: 'https://graph.microsoft.com/'
			},
		};
	}
}
